import axios from 'axios/dist/axios';


const defaultState = {
    evaluationData: {},
    isLoadingEvaluationData: false,
    usedShortcut: false
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    evaluationData: defaultState.evaluationData,
    isLoadingEvaluationData: defaultState.isLoadingEvaluationData,
    usedShortcut: defaultState.usedShortcut
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getEvaluationData: state => state.evaluationData,
    getIsLoadingEvaluationData: state => state.isLoadingEvaluationData,
    getUsedShortcut: state => state.usedShortcut
};


// ======================================================================
// Actions
// ======================================================================

const actions = {
    loadEvaluationData ({ commit, dispatch }) {
        let promise;
        if(!state.usedShortcut) {
             promise = new Promise((resolve, reject) => {
                commit("setIsLoadingEvaluationData", true);
                let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/evaluateAssessment');
                axiosRequest.then((response) => {
                    // ----- Success. -----
                    if (typeof response.data.data.SCORING !== "undefined") {
                        commit('setEvaluationData', response.data.data.SCORING);
                    }

                    if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                        commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                    }
                    if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                        commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                    }

                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, {root: true});

                    resolve(response);
                });
                axiosRequest.catch((error) => {
                    // ----- Failure -----
                    console.log(error);
                    reject(error);
                });
                axiosRequest.then(() => {
                    // ----- Always -----
                    commit("setIsLoadingEvaluationData", false);
                });
            })
        }
        else {
            promise = new Promise((resolve, reject) => {
                const data = {
                    shortcutUsed: false,
                    urgentEvaluate: true
                };
                let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/evaluateAssessment', data);
                axiosRequest.then((response) => {
                    if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                        resolve(response);
                        if (typeof response.data.data.SCORING !== "undefined") {
                            commit('setEvaluationData', response.data.data.SCORING);
                        }

                        if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                            commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                        }
                        if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                            commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                        }

                        dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });
                    }
                    else {
                        reject(error);
                    }
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                    reject(error);
                });
            });
        }

        return promise;
    },

    // evaluateAssessment ({ commit }, shortCutParam) {
    //     let promise = new Promise((resolve, reject) => {
    //         const data = {
    //             shortcutUsed: shortCutParam.shortcutUsed,
    //             urgentEvaluate: shortCutParam.urgentEvaluate
    //         };
    //         let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/evaluateAssessment', data);
    //         axiosRequest.then((response) => {
    //             if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
    //                 resolve(response);
    //                 if (typeof response.data.data.SCORING_V1 !== "undefined") {
    //                     commit('setEvaluationData', response.data.data.SCORING_V1);
    //                 }
    //
    //                 if (typeof response.data.data.START_QUESTIONS !== "undefined") {
    //                     commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
    //                 }
    //                 if (typeof response.data.data.PATIENT_DATA !== "undefined") {
    //                     commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
    //                 }
    //
    //                 dispatch("AssessmentAlertsStore/refreshAlerts", response.data.assessment, { root: true });
    //             }
    //             else {
    //                 reject(error);
    //             }
    //         });
    //         axiosRequest.catch((error) => {
    //             console.log(error);
    //             reject(error);
    //         });
    //     });
    //
    //     return promise;
    // }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {
    setEvaluationData (state, data) {
        state.evaluationData = data;
    },
    setIsLoadingEvaluationData (state, newValue) {
        state.isLoadingEvaluationData = newValue;
    },

    setUsedShortcut (state, newValue) {
      state.usedShortcut = newValue;
    },

    // ----------------------------------------------------------

    resetStore (state) {
        state.evaluationData = defaultState.evaluationData;
        state.usedShortcut = defaultState.usedShortcut
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfEvaluationStore.js